import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import http from "../http";
const initialState = {
    mapData: null,
    status: null
}
// export const fetchScenic = createAsyncThunk('scenic', async () => {
//     const response= await http.post('/v1/scenic',{limit:99},{
//         headers:{
//             'Content-Type': 'multipart/form-data',
//             'Accept':'*/*'
//         }
//     })
//     return response.data
// })
// const fomrdata=new FormData();
// fomrdata.append('limit',1)
export const fetchScenic = createAsyncThunk('scenic', async () => {
    const response = await http.post("/v1/scenic", { 'limit': 999 })
    return response.data
})

const mapSlice = createSlice({
    name: 'todos',
    initialState,
    reducers: {
        // todoAdded(state, action) {
        //     // ✅ “突变”（mutate）代码在 createSlice 中是可以的！
        //     state.entities.push(action.payload)
        // },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchScenic.pending, (state, action) => {
                // state.status = 'loading'
            })
            .addCase(fetchScenic.fulfilled, (state, action) => {
                if (action.payload.isSuccess == 1) {
                    state.mapData = action.payload.item;
                    // console.log(state.mapData)
                }
                // const newEntities = {}
                // action.payload.forEach(todo => {
                //     newEntities[todo.id] = todo
                // })
                // state.entities = newEntities
                // state.status = 'idle'
            })
            .addCase(fetchScenic.rejected, (state, action) => {

            })
    }
})

export default mapSlice.reducer